import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App, Form } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  accountLinkedAuthMethodsRetrieveQueryKey,
  accountUserPartialUpdateMutation
} from 'src/api/main/@tanstack/react-query.gen'
import { useShowApiErrors } from 'src/utils'

export const useSetPasswordModal = () => {
  const { t } = useTranslation()
  const { message } = App.useApp()
  const showApiErrors = useShowApiErrors()
  const queryClient = useQueryClient()
  const [form] = Form.useForm<{
    new_password: string
    confirm_password: string
  }>()
  const [isOpen, setIsOpen] = useState(false)

  const setPasswordMutation = useMutation({
    ...accountUserPartialUpdateMutation(),
    onSuccess: async () => {
      message.success(t('account.messages.passwordSet'))
      setIsOpen(false)
      form.resetFields()
      await queryClient.invalidateQueries({
        queryKey: accountLinkedAuthMethodsRetrieveQueryKey()
      })
    },
    onError: (error) => showApiErrors(error)
  })

  return {
    closeModal: () => {
      setIsOpen(false)
      form.resetFields()
    },
    form,
    isOpen,
    isPending: setPasswordMutation.isPending,
    openModal: () => {
      setIsOpen(true)
    },
    submit: () => {
      form.validateFields().then((values) => {
        setPasswordMutation.mutate({
          body: {
            confirm_password: values.confirm_password,
            new_password: values.new_password
          }
        })
      })
    }
  }
}
